var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobAppContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 381,
    viewBox: "0 0 486 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M485.988 337.12H0.579102V337.362H485.988V337.12Z",
    fill: "#C9DDF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M437.35 352.74H405.196V352.983H437.35V352.74Z",
    fill: "#C9DDF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M322.134 355.381H313.697V355.624H322.134V355.381Z",
    fill: "#C9DDF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M404.226 343.731H385.596V343.974H404.226V343.731Z",
    fill: "#C9DDF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4375 345.362H51.5078V345.605H93.4375V345.362Z",
    fill: "#C9DDF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.233 345.362H102.088V345.605H108.233V345.362Z",
    fill: "#C9DDF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.159 349.459H128.213V349.701H219.159V349.459Z",
    fill: "#C9DDF1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M423.827 337.12H454.602V282.638H423.827V337.12Z",
    fill: "#DCEAF8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M396.876 337.12H427.651V294.588H396.876V337.12Z",
    fill: "#DCEAF8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M377.199 337.12H407.974V259.542H377.199V337.12Z",
    fill: "#DCEAF8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M356.753 337.12H387.528V196.642H356.753V337.12Z",
    fill: "#DCEAF8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M280.641 337.12H363.219V207.574H280.641V337.12Z",
    fill: "#DCEAF8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.915 288.365H27.3447V337.12H70.915V288.365Z",
    fill: "#EBF5FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.068 299.054H65.498V337.11H109.068V299.054Z",
    fill: "#EBF5FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M136.931 267.697H93.3604V337.12H136.931V267.697Z",
    fill: "#EBF5FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M165.89 211.408H122.319V337.12H165.89V211.408Z",
    fill: "#EBF5FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M157.095 337.12H228.392L228.392 183.546H157.095V337.12Z",
    fill: "#DCEAF8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M163.871 208.68H167.269V189.992H163.871V208.68Z",
    fill: "#EBF5FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M163.871 237.892H167.269V219.204H163.871V237.892Z",
    fill: "#EBF5FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M163.871 267.124H167.269V248.436H163.871V267.124Z",
    fill: "#EBF5FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M163.871 296.345H167.269V277.657H163.871V296.345Z",
    fill: "#EBF5FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M163.871 325.567H167.269V306.879H163.871V325.567Z",
    fill: "#EBF5FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M175.909 208.68H179.307V189.992H175.909V208.68Z",
    fill: "#EBF5FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M175.909 237.892H179.307V219.204H175.909V237.892Z",
    fill: "#EBF5FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M175.909 267.124H179.307V248.436H175.909V267.124Z",
    fill: "#EBF5FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M175.909 296.345H179.307V277.657H175.909V296.345Z",
    fill: "#EBF5FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M175.909 325.567H179.307V306.879H175.909V325.567Z",
    fill: "#EBF5FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M187.937 208.68H191.335V189.992H187.937V208.68Z",
    fill: "#EBF5FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M187.937 237.892H191.335V219.204H187.937V237.892Z",
    fill: "#EBF5FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M187.937 267.124H191.335V248.436H187.937V267.124Z",
    fill: "#EBF5FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M187.937 296.345H191.335V277.657H187.937V296.345Z",
    fill: "#EBF5FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M187.937 325.567H191.335V306.879H187.937V325.567Z",
    fill: "#EBF5FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M199.975 208.68H203.373V189.992H199.975V208.68Z",
    fill: "#EBF5FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M199.975 237.892H203.373V219.204H199.975V237.892Z",
    fill: "#EBF5FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M199.975 267.124H203.373V248.436H199.975V267.124Z",
    fill: "#EBF5FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M199.975 296.345H203.373V277.657H199.975V296.345Z",
    fill: "#EBF5FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M199.975 325.567H203.373V306.879H199.975V325.567Z",
    fill: "#EBF5FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M211.995 208.68H215.393V189.992H211.995V208.68Z",
    fill: "#EBF5FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M211.995 237.892H215.393V219.204H211.995V237.892Z",
    fill: "#EBF5FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M211.995 267.124H215.393V248.436H211.995V267.124Z",
    fill: "#EBF5FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M211.995 296.345H215.393V277.657H211.995V296.345Z",
    fill: "#EBF5FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M211.995 325.567H215.393V306.879H211.995V325.567Z",
    fill: "#EBF5FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M228.391 183.546H213.693L207.305 337.12H228.391V183.546Z",
    fill: "#E3F4FA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M346.055 77.688L259.564 87.5515V337.12H346.055V77.688Z",
    fill: "#DCEAF8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 77.688H346.055V337.12H415.255V77.688Z",
    fill: "#C9DDF1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 99.1819H259.564V100.512H415.255V99.1819Z",
    fill: "#E3F4FA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 113.307H259.564V114.637H415.255V113.307Z",
    fill: "#E3F4FA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 127.433H259.564V128.763H415.255V127.433Z",
    fill: "#E3F4FA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 141.558H259.564V142.888H415.255V141.558Z",
    fill: "#E3F4FA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 155.684H259.564V157.014H415.255V155.684Z",
    fill: "#E3F4FA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 169.809H259.564V171.139H415.255V169.809Z",
    fill: "#E3F4FA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 183.934H259.564V185.264H415.255V183.934Z",
    fill: "#E3F4FA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 198.06H259.564V199.39H415.255V198.06Z",
    fill: "#E3F4FA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 212.185H259.564V213.515H415.255V212.185Z",
    fill: "#E3F4FA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 226.311H259.564V227.641H415.255V226.311Z",
    fill: "#E3F4FA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 240.436H259.564V241.766H415.255V240.436Z",
    fill: "#E3F4FA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 254.571H259.564V255.901H415.255V254.571Z",
    fill: "#E3F4FA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 268.697H259.564V270.027H415.255V268.697Z",
    fill: "#E3F4FA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 282.822H259.564V284.152H415.255V282.822Z",
    fill: "#E3F4FA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 296.947H259.564V298.277H415.255V296.947Z",
    fill: "#E3F4FA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 311.073H259.564V312.403H415.255V311.073Z",
    fill: "#E3F4FA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M415.255 325.198H259.564V326.528H415.255V325.198Z",
    fill: "#E3F4FA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M105.447 337.12H146.474L146.474 122.967H105.447L105.447 337.12Z",
    fill: "#DCEAF8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M105.447 122.967H146.474L131.378 104.055H72.624L105.447 122.967Z",
    fill: "#FAFAFA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M105.447 122.967L72.624 104.055V337.12H105.447V122.967Z",
    fill: "#C9DDF1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 134.083H146.474V132.947H72.6332V134.083Z",
    fill: "#E3F4FA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 146.208H146.474V145.072H72.6332V146.208Z",
    fill: "#E3F4FA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 158.334H146.474V157.198H72.6332V158.334Z",
    fill: "#E3F4FA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 170.45H146.474V169.314H72.6332V170.45Z",
    fill: "#E3F4FA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 182.575H146.474V181.439H72.6332V182.575Z",
    fill: "#E3F4FA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 194.691H146.474V193.555H72.6332V194.691Z",
    fill: "#E3F4FA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 206.816H146.474V205.681H72.6332V206.816Z",
    fill: "#E3F4FA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 218.942H146.474V217.806H72.6332V218.942Z",
    fill: "#E3F4FA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 231.058H146.474V229.922H72.6332V231.058Z",
    fill: "#E3F4FA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 243.183H146.474V242.047H72.6332V243.183Z",
    fill: "#E3F4FA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 255.299H146.474V254.163H72.6332V255.299Z",
    fill: "#E3F4FA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 267.425H146.474V266.289H72.6332V267.425Z",
    fill: "#E3F4FA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 279.541H146.474V278.405H72.6332V279.541Z",
    fill: "#E3F4FA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 291.666H146.474V290.53H72.6332V291.666Z",
    fill: "#E3F4FA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 303.792H146.474V302.656H72.6332V303.792Z",
    fill: "#E3F4FA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 315.907H146.474V314.771H72.6332V315.907Z",
    fill: "#E3F4FA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6332 328.033H146.474V326.897H72.6332V328.033Z",
    fill: "#E3F4FA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M250.429 337.11H305.756V146.169H250.429L250.429 337.11Z",
    fill: "#DCEAF8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M285.971 186.691H294.854V156.043H285.971V186.691Z",
    fill: "#C9DDF1"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M264.195 186.691H273.078V156.043H264.195V186.691Z",
    fill: "#C9DDF1"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M285.971 226.378H294.854V195.73H285.971V226.378Z",
    fill: "#C9DDF1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M264.195 226.378H273.078V195.73H264.195V226.378Z",
    fill: "#C9DDF1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M285.971 266.065H294.854V235.417H285.971V266.065Z",
    fill: "#C9DDF1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M264.195 266.065H273.078V235.417H264.195V266.065Z",
    fill: "#C9DDF1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M285.971 305.752H294.854V275.104H285.971V305.752Z",
    fill: "#C9DDF1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M264.195 305.752H273.078V275.104H264.195V305.752Z",
    fill: "#C9DDF1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M250.419 146.179H305.746L292.776 132.947H237.449L250.419 146.179Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M250.419 146.179L237.449 132.947L224.469 146.179V337.12H250.419V146.179Z",
    fill: "#C9DDF1"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M185.287 111.424C200.01 111.424 211.945 99.4883 211.945 84.7651C211.945 70.0419 200.01 58.1064 185.287 58.1064C170.563 58.1064 158.628 70.0419 158.628 84.7651C158.628 99.4883 170.563 111.424 185.287 111.424Z",
    fill: "#FAFAFA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M381.956 44.2044C375.325 43.5637 369.238 38.8746 360.598 37.5834C356.297 36.9427 353.802 38.5542 351.258 40.0687C348.074 42.0104 344.181 42.9812 339.298 42.8647C332.876 42.6938 326.519 41.5279 320.454 39.4086C314.979 37.5446 309.261 35.3117 304.921 36.1175C296.873 37.5931 296.64 42.9132 289.98 43.6704C283.321 44.4277 282.107 48.0197 287.631 48.0197H388.81C393.644 48.0197 388.596 44.8354 381.956 44.2044Z",
    fill: "#EBF5FF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M96.583 43.0978C93.787 44.7385 88.2631 43.7482 79.1956 42.3308C73.8755 41.5056 71.2349 43.2046 67.5458 44.7287C66.0702 45.3501 59.5851 47.4762 68.0506 47.4762H115.135C128.183 47.4762 116.048 45.1462 113.961 44.2433H113.854C107.611 41.4668 99.3692 41.4668 96.583 43.0978Z",
    fill: "#EBF5FF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M126.786 80.28H178.239C182.744 80.28 178.045 77.3093 171.861 76.7171C165.677 76.1249 160.007 71.7562 151.92 70.5524C143.833 69.3486 143.62 75.8919 132.999 75.824C124.417 75.7851 118.048 80.28 126.786 80.28Z",
    fill: "#EBF5FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M243.284 380.962C347.241 380.962 431.516 376.041 431.516 369.972C431.516 363.903 347.241 358.982 243.284 358.982C139.326 358.982 55.0518 363.903 55.0518 369.972C55.0518 376.041 139.326 380.962 243.284 380.962Z",
    fill: "#EBF5FF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M133.698 142.966C133.404 142.966 133.123 142.849 132.915 142.641C132.707 142.434 132.591 142.152 132.591 141.859V52.9707C132.591 52.6772 132.707 52.3957 132.915 52.1882C133.123 51.9806 133.404 51.864 133.698 51.864C133.991 51.864 134.273 51.9806 134.48 52.1882C134.688 52.3957 134.804 52.6772 134.804 52.9707V141.859C134.804 142.152 134.688 142.434 134.48 142.641C134.273 142.849 133.991 142.966 133.698 142.966Z",
    fill: "url(#paint0_linear_484_4922)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M163.327 142.966C163.034 142.966 162.752 142.849 162.545 142.642C162.337 142.434 162.221 142.153 162.221 141.859V52.9709C162.206 52.8162 162.224 52.6602 162.273 52.5128C162.323 52.3655 162.402 52.23 162.507 52.1152C162.612 52.0003 162.739 51.9085 162.881 51.8457C163.023 51.7829 163.177 51.7505 163.332 51.7505C163.488 51.7505 163.641 51.7829 163.783 51.8457C163.926 51.9085 164.053 52.0003 164.158 52.1152C164.262 52.23 164.342 52.3655 164.391 52.5128C164.44 52.6602 164.458 52.8162 164.444 52.9709V141.859C164.441 142.153 164.323 142.435 164.113 142.642C163.904 142.849 163.622 142.966 163.327 142.966Z",
    fill: "url(#paint1_linear_484_4922)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M163.328 83.7071C163.034 83.7081 162.751 83.5929 162.541 83.3867L148.513 69.3584L134.485 83.3479C134.271 83.527 133.997 83.6196 133.719 83.6072C133.44 83.5949 133.176 83.4786 132.979 83.2813C132.781 83.084 132.665 82.82 132.653 82.5412C132.64 82.2624 132.733 81.9891 132.912 81.7752L146.94 67.8148L132.912 53.7574C132.743 53.6037 132.625 53.402 132.575 53.1795C132.524 52.9569 132.543 52.7241 132.629 52.5125C132.714 52.301 132.863 52.1207 133.054 51.9961C133.245 51.8716 133.47 51.8086 133.698 51.8157H163.328C163.548 51.8162 163.763 51.8819 163.947 52.0046C164.13 52.1273 164.272 52.3014 164.357 52.505C164.442 52.7085 164.464 52.9327 164.421 53.1489C164.378 53.3651 164.271 53.5635 164.114 53.7185L150.086 67.8148L164.114 81.8431C164.289 81.9943 164.412 82.1963 164.466 82.4208C164.52 82.6454 164.502 82.8812 164.415 83.0952C164.329 83.3093 164.177 83.4908 163.982 83.6145C163.787 83.7381 163.558 83.7977 163.328 83.7848V83.7071ZM136.378 54.0777L148.513 66.213L160.648 54.0777H136.378Z",
    fill: "url(#paint2_linear_484_4922)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M133.698 54.0777C133.478 54.0792 133.263 54.0152 133.079 53.8937C132.896 53.7722 132.753 53.5987 132.669 53.3956C132.584 53.1924 132.562 52.9687 132.606 52.753C132.649 52.5373 132.756 52.3394 132.912 52.1846L147.727 37.3699C147.83 37.266 147.952 37.1836 148.087 37.1273C148.222 37.071 148.367 37.042 148.513 37.042C148.659 37.042 148.804 37.071 148.939 37.1273C149.074 37.1836 149.196 37.266 149.299 37.3699L164.114 52.1846C164.218 52.2875 164.3 52.41 164.357 52.545C164.413 52.68 164.442 52.8248 164.442 52.971C164.442 53.1172 164.413 53.262 164.357 53.397C164.3 53.532 164.218 53.6544 164.114 53.7574C163.904 53.9625 163.622 54.0774 163.328 54.0774C163.034 54.0774 162.752 53.9625 162.541 53.7574L148.513 39.729L134.485 53.7574C134.275 53.9635 133.992 54.0787 133.698 54.0777Z",
    fill: "url(#paint3_linear_484_4922)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M192.957 54.0777C192.663 54.0766 192.381 53.9618 192.17 53.7574L178.142 39.729L164.114 53.7574C163.903 53.9625 163.621 54.0774 163.327 54.0774C163.033 54.0774 162.751 53.9625 162.541 53.7574C162.437 53.6544 162.354 53.532 162.298 53.397C162.242 53.262 162.213 53.1172 162.213 52.971C162.213 52.8248 162.242 52.68 162.298 52.545C162.354 52.41 162.437 52.2875 162.541 52.1846L177.356 37.3699C177.458 37.266 177.581 37.1836 177.716 37.1273C177.851 37.071 177.996 37.042 178.142 37.042C178.288 37.042 178.433 37.071 178.568 37.1273C178.703 37.1836 178.825 37.266 178.928 37.3699L193.772 52.1846C193.928 52.3394 194.035 52.5373 194.078 52.753C194.122 52.9687 194.1 53.1924 194.015 53.3956C193.931 53.5987 193.788 53.7722 193.605 53.8937C193.421 54.0152 193.206 54.0792 192.986 54.0777H192.957Z",
    fill: "url(#paint4_linear_484_4922)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M192.957 54.0777C192.663 54.0766 192.382 53.9618 192.171 53.7574C192.067 53.6545 191.984 53.532 191.928 53.397C191.872 53.262 191.843 53.1172 191.843 52.971C191.843 52.8248 191.872 52.68 191.928 52.545C191.984 52.41 192.067 52.2875 192.171 52.1846L206.985 37.3699C207.088 37.266 207.211 37.1836 207.346 37.1273C207.481 37.071 207.626 37.042 207.772 37.042C207.918 37.042 208.063 37.071 208.198 37.1273C208.333 37.1836 208.455 37.266 208.558 37.3699L223.373 52.1846C223.477 52.2875 223.559 52.41 223.615 52.545C223.672 52.68 223.701 52.8248 223.701 52.971C223.701 53.1172 223.672 53.262 223.615 53.397C223.559 53.532 223.477 53.6545 223.373 53.7574C223.162 53.9625 222.88 54.0774 222.586 54.0774C222.293 54.0774 222.01 53.9625 221.8 53.7574L207.772 39.729L193.773 53.7574C193.665 53.863 193.538 53.9458 193.398 54.0009C193.257 54.0559 193.108 54.0821 192.957 54.0777Z",
    fill: "url(#paint5_linear_484_4922)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M133.698 113.336C133.478 113.338 133.263 113.274 133.079 113.152C132.896 113.031 132.753 112.857 132.669 112.654C132.584 112.451 132.562 112.227 132.606 112.012C132.649 111.796 132.756 111.598 132.912 111.443L162.541 81.8139C162.755 81.6347 163.029 81.5422 163.307 81.5546C163.586 81.5669 163.85 81.6832 164.047 81.8805C164.245 82.0778 164.361 82.3418 164.373 82.6206C164.386 82.8994 164.293 83.1726 164.114 83.3866L134.485 113.016C134.275 113.222 133.992 113.337 133.698 113.336Z",
    fill: "url(#paint6_linear_484_4922)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M163.328 113.336C163.033 113.337 162.751 113.222 162.541 113.016L132.912 83.3478C132.733 83.1338 132.64 82.8605 132.652 82.5818C132.665 82.303 132.781 82.039 132.978 81.8417C133.176 81.6443 133.44 81.5281 133.718 81.5157C133.997 81.5034 134.271 81.5959 134.484 81.7751L164.114 111.404C164.27 111.559 164.377 111.757 164.42 111.973C164.464 112.188 164.442 112.412 164.357 112.615C164.273 112.819 164.13 112.992 163.946 113.113C163.763 113.235 163.547 113.299 163.328 113.298V113.336Z",
    fill: "url(#paint7_linear_484_4922)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M163.327 142.966H133.698C133.479 142.967 133.263 142.904 133.08 142.782C132.897 142.661 132.754 142.489 132.669 142.286C132.587 142.082 132.566 141.859 132.609 141.643C132.652 141.427 132.757 141.229 132.912 141.073L146.94 127.035L132.912 113.006C132.733 112.792 132.64 112.519 132.652 112.24C132.665 111.961 132.781 111.697 132.978 111.5C133.176 111.303 133.44 111.187 133.718 111.174C133.997 111.162 134.271 111.254 134.484 111.433L148.513 125.462L162.541 111.433C162.755 111.254 163.028 111.162 163.307 111.174C163.586 111.187 163.85 111.303 164.047 111.5C164.245 111.697 164.361 111.961 164.373 112.24C164.386 112.519 164.293 112.792 164.114 113.006L150.086 127.035L164.114 141.063C164.27 141.218 164.377 141.416 164.42 141.631C164.463 141.847 164.442 142.071 164.357 142.274C164.273 142.477 164.13 142.65 163.946 142.772C163.763 142.893 163.547 142.957 163.327 142.956V142.966ZM136.378 140.752H160.648L148.513 128.617L136.378 140.752Z",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M123.33 68.97H107.506L109.496 52.9709H121.33L123.33 68.97Z",
    fill: "url(#paint8_linear_484_4922)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M123.33 70.0766H107.506C107.349 70.0762 107.193 70.0432 107.05 69.9797C106.906 69.9162 106.777 69.8235 106.671 69.7076C106.568 69.5882 106.491 69.4491 106.445 69.2988C106.398 69.1486 106.382 68.9904 106.399 68.8339L108.399 52.8348C108.432 52.5671 108.562 52.3207 108.764 52.1419C108.966 51.9632 109.226 51.8643 109.496 51.864H121.33C121.601 51.8641 121.863 51.9626 122.066 52.1412C122.27 52.3198 122.402 52.5663 122.437 52.8348L124.379 68.8339C124.398 68.9894 124.384 69.1473 124.337 69.297C124.291 69.4467 124.214 69.5848 124.11 69.7023C124.006 69.8198 123.879 69.9139 123.736 69.9784C123.593 70.0429 123.438 70.0764 123.282 70.0766H123.33ZM108.768 67.8534H122.068L120.35 54.0775H110.486L108.768 67.8534Z",
    fill: "url(#paint9_linear_484_4922)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M222.586 54.0776H105.001C104.846 54.0921 104.69 54.0741 104.543 54.0249C104.395 53.9756 104.26 53.8961 104.145 53.7914C104.03 53.6868 103.938 53.5594 103.876 53.4172C103.813 53.2751 103.78 53.1214 103.78 52.9661C103.78 52.8107 103.813 52.657 103.876 52.5149C103.938 52.3727 104.03 52.2453 104.145 52.1407C104.26 52.036 104.395 51.9565 104.543 51.9073C104.69 51.858 104.846 51.84 105.001 51.8545H222.586C222.741 51.84 222.897 51.858 223.044 51.9073C223.192 51.9565 223.327 52.036 223.442 52.1407C223.557 52.2453 223.649 52.3727 223.711 52.5149C223.774 52.657 223.807 52.8107 223.807 52.9661C223.807 53.1214 223.774 53.2751 223.711 53.4172C223.649 53.5594 223.557 53.6868 223.442 53.7914C223.327 53.8961 223.192 53.9756 223.044 54.0249C222.897 54.0741 222.741 54.0921 222.586 54.0776Z",
    fill: "#263238"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M207.771 39.2629H148.552C148.275 39.237 148.017 39.1087 147.83 38.9031C147.643 38.6975 147.539 38.4294 147.539 38.1514C147.539 37.8733 147.643 37.6052 147.83 37.3996C148.017 37.194 148.275 37.0657 148.552 37.0398H207.771C207.926 37.0253 208.082 37.0433 208.23 37.0925C208.377 37.1418 208.512 37.2213 208.627 37.326C208.742 37.4306 208.834 37.558 208.897 37.7002C208.959 37.8423 208.992 37.996 208.992 38.1514C208.992 38.3067 208.959 38.4604 208.897 38.6025C208.834 38.7447 208.742 38.8721 208.627 38.9767C208.512 39.0814 208.377 39.1609 208.23 39.2102C208.082 39.2594 207.926 39.2774 207.771 39.2629Z",
    fill: "url(#paint10_linear_484_4922)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M238.148 102.716H123.912C117.869 102.716 112.971 107.614 112.971 113.657V354.526C112.971 360.569 117.869 365.468 123.912 365.468H238.148C244.191 365.468 249.089 360.569 249.089 354.526V113.657C249.089 107.614 244.191 102.716 238.148 102.716Z",
    fill: "url(#paint11_linear_484_4922)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M238.148 102.716H123.912C117.869 102.716 112.971 107.614 112.971 113.657V354.526C112.971 360.569 117.869 365.468 123.912 365.468H238.148C244.191 365.468 249.089 360.569 249.089 354.526V113.657C249.089 107.614 244.191 102.716 238.148 102.716Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M252.128 102.716H137.892C131.85 102.716 126.951 107.614 126.951 113.657V354.526C126.951 360.569 131.85 365.468 137.892 365.468H252.128C258.171 365.468 263.07 360.569 263.07 354.526V113.657C263.07 107.614 258.171 102.716 252.128 102.716Z",
    fill: "url(#paint12_linear_484_4922)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M258.507 354.527V113.647C258.507 110.124 255.651 107.269 252.129 107.269L137.883 107.269C134.36 107.269 131.504 110.124 131.504 113.647V354.527C131.504 358.049 134.36 360.905 137.883 360.905H252.129C255.651 360.905 258.507 358.049 258.507 354.527Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M256.687 253.489L251.455 145.738C251.243 141.379 247.537 138.017 243.178 138.228L149.915 142.757C145.555 142.969 142.193 146.674 142.405 151.034L147.637 258.784C147.849 263.143 151.554 266.506 155.913 266.294L249.177 261.765C253.536 261.553 256.898 257.848 256.687 253.489Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M254.866 119.734V115.171C254.866 112.823 252.962 110.919 250.614 110.919H139.407C137.058 110.919 135.155 112.823 135.155 115.171V119.734C135.155 122.082 137.058 123.986 139.407 123.986H250.614C252.962 123.986 254.866 122.082 254.866 119.734Z",
    fill: "url(#paint13_linear_484_4922)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M147.814 120.511C147.002 120.511 146.223 120.189 145.648 119.616C145.073 119.042 144.749 118.264 144.746 117.453C144.749 116.64 145.073 115.861 145.647 115.286C146.222 114.711 147.001 114.387 147.814 114.385C148.627 114.387 149.406 114.711 149.98 115.286C150.555 115.861 150.879 116.64 150.882 117.453C150.879 118.264 150.555 119.042 149.98 119.616C149.405 120.189 148.626 120.511 147.814 120.511Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M156.93 120.511C156.118 120.511 155.339 120.189 154.764 119.616C154.189 119.042 153.865 118.264 153.862 117.453C153.865 116.64 154.189 115.861 154.764 115.286C155.338 114.711 156.117 114.387 156.93 114.385C157.742 114.387 158.52 114.712 159.093 115.287C159.666 115.862 159.988 116.641 159.988 117.453C159.986 118.263 159.663 119.039 159.09 119.612C158.517 120.185 157.74 120.508 156.93 120.511Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M166.045 120.511C165.233 120.511 164.455 120.189 163.88 119.616C163.304 119.042 162.98 118.264 162.978 117.453C162.98 116.64 163.304 115.861 163.879 115.286C164.454 114.711 165.232 114.387 166.045 114.385C166.857 114.387 167.635 114.712 168.208 115.287C168.782 115.862 169.103 116.641 169.103 117.453C169.101 118.263 168.778 119.039 168.205 119.612C167.632 120.185 166.856 120.508 166.045 120.511Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M246.332 113.647H242.08C241.158 113.647 240.41 114.395 240.41 115.317V119.569C240.41 120.491 241.158 121.239 242.08 121.239H246.332C247.254 121.239 248.002 120.491 248.002 119.569V115.317C248.002 114.395 247.254 113.647 246.332 113.647Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M173.177 309.25C184.031 304.755 189.185 292.312 184.689 281.459C180.193 270.606 167.751 265.452 156.898 269.947C146.044 274.443 140.89 286.886 145.386 297.739C149.882 308.592 162.324 313.746 173.177 309.25Z",
    fill: "url(#paint14_linear_484_4922)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M240.963 279.929H199.49C198.785 279.926 198.11 279.645 197.612 279.147C197.114 278.648 196.833 277.973 196.83 277.269C196.833 276.564 197.114 275.889 197.612 275.391C198.11 274.892 198.785 274.611 199.49 274.609H240.963C241.669 274.609 242.346 274.889 242.844 275.388C243.343 275.887 243.624 276.563 243.624 277.269C243.624 277.974 243.343 278.651 242.844 279.15C242.346 279.648 241.669 279.929 240.963 279.929Z",
    fill: "url(#paint15_linear_484_4922)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M240.963 292.258H199.49C198.785 292.256 198.11 291.974 197.612 291.476C197.114 290.978 196.833 290.303 196.83 289.598C196.833 288.893 197.114 288.218 197.612 287.72C198.11 287.222 198.785 286.941 199.49 286.938H240.963C241.669 286.938 242.346 287.218 242.844 287.717C243.343 288.216 243.624 288.893 243.624 289.598C243.624 290.304 243.343 290.98 242.844 291.479C242.346 291.978 241.669 292.258 240.963 292.258Z",
    fill: "url(#paint16_linear_484_4922)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M240.963 299.267H199.49C198.021 299.267 196.83 300.458 196.83 301.927C196.83 303.396 198.021 304.587 199.49 304.587H240.963C242.433 304.587 243.624 303.396 243.624 301.927C243.624 300.458 242.433 299.267 240.963 299.267Z",
    fill: "url(#paint17_linear_484_4922)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M236.731 322.81H153.299C148.034 322.81 143.766 327.078 143.766 332.343V344.197C143.766 349.462 148.034 353.73 153.299 353.73H236.731C241.996 353.73 246.265 349.462 246.265 344.197V332.343C246.265 327.078 241.996 322.81 236.731 322.81Z",
    fill: "#E3F4FA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M268.173 245.691L259.784 138.14C259.445 133.789 255.643 130.537 251.291 130.876L158.201 138.137C153.85 138.476 150.597 142.279 150.937 146.63L159.326 254.181C159.665 258.532 163.468 261.784 167.819 261.445L260.909 254.184C265.26 253.844 268.513 250.042 268.173 245.691Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M167.182 261.978C165.068 261.974 163.033 261.172 161.485 259.732C159.937 258.292 158.99 256.32 158.833 254.212L150.445 146.655C150.276 144.439 150.993 142.246 152.438 140.557C153.883 138.869 155.938 137.822 158.153 137.646L251.255 130.384C253.471 130.215 255.664 130.932 257.352 132.376C259.041 133.821 260.088 135.877 260.264 138.092L268.652 245.649C268.824 247.867 268.108 250.062 266.663 251.753C265.218 253.444 263.161 254.492 260.944 254.668L167.842 261.92C167.619 261.978 167.405 261.978 167.182 261.978ZM159.804 254.212C159.962 256.167 160.889 257.98 162.381 259.253C163.873 260.527 165.809 261.158 167.765 261.008L260.866 253.746C262.822 253.585 264.635 252.656 265.908 251.163C267.182 249.669 267.812 247.732 267.662 245.775L259.274 138.218C259.115 136.261 258.187 134.447 256.693 133.173C255.199 131.899 253.261 131.27 251.303 131.423L158.212 138.684C156.256 138.845 154.443 139.774 153.17 141.268C151.896 142.761 151.266 144.698 151.416 146.655L159.804 254.212Z",
    fill: "url(#paint18_linear_484_4922)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M264.125 243.785L262.266 219.947C261.998 216.509 258.994 213.94 255.557 214.209L166.899 221.124C163.462 221.392 160.893 224.396 161.161 227.833L163.021 251.672C163.289 255.109 166.292 257.678 169.729 257.41L258.387 250.494C261.824 250.226 264.393 247.223 264.125 243.785Z",
    fill: "url(#paint19_linear_484_4922)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.534 207.641L206.616 144.593C206.345 141.113 203.304 138.512 199.824 138.784L160.799 141.828C157.319 142.099 154.718 145.14 154.99 148.62L159.908 211.668C160.179 215.147 163.22 217.748 166.7 217.477L205.725 214.433C209.205 214.162 211.806 211.121 211.534 207.641Z",
    fill: "url(#paint20_linear_484_4922)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M256.502 150.216L255.668 139.521C255.45 136.725 253.007 134.636 250.211 134.854L216.771 137.462C213.976 137.68 211.886 140.123 212.104 142.919L212.938 153.614C213.156 156.409 215.599 158.499 218.395 158.281L251.835 155.673C254.631 155.455 256.721 153.011 256.502 150.216Z",
    fill: "url(#paint21_linear_484_4922)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M258.635 177.631L257.801 166.936C257.583 164.14 255.14 162.051 252.344 162.269L218.904 164.877C216.108 165.095 214.019 167.538 214.237 170.334L215.071 181.029C215.289 183.824 217.732 185.914 220.528 185.696L253.968 183.088C256.764 182.87 258.853 180.427 258.635 177.631Z",
    fill: "url(#paint22_linear_484_4922)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M260.778 205.046L259.944 194.351C259.726 191.556 257.282 189.466 254.487 189.684L221.047 192.292C218.251 192.511 216.161 194.954 216.379 197.749L217.214 208.444C217.432 211.24 219.875 213.33 222.671 213.112L256.111 210.503C258.906 210.285 260.996 207.842 260.778 205.046Z",
    fill: "url(#paint23_linear_484_4922)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M220.227 117.948C220.096 117.948 219.97 117.896 219.877 117.803C219.785 117.71 219.732 117.584 219.732 117.453V52.9709C219.718 52.899 219.72 52.8248 219.737 52.7537C219.755 52.6826 219.788 52.6163 219.835 52.5596C219.881 52.5029 219.94 52.4572 220.006 52.4258C220.072 52.3944 220.144 52.3782 220.218 52.3782C220.291 52.3782 220.363 52.3944 220.43 52.4258C220.496 52.4572 220.554 52.5029 220.601 52.5596C220.647 52.6163 220.681 52.6826 220.698 52.7537C220.716 52.8248 220.718 52.899 220.703 52.9709V117.453C220.703 117.581 220.654 117.704 220.565 117.796C220.476 117.888 220.355 117.943 220.227 117.948Z",
    fill: "#263238"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M226.392 128.005H214.062C213.571 128.005 213.093 127.846 212.7 127.552C212.306 127.258 212.018 126.845 211.878 126.374L209.228 117.365C209.13 117.026 209.112 116.669 209.176 116.322C209.24 115.975 209.383 115.647 209.595 115.365C209.807 115.083 210.081 114.854 210.396 114.695C210.711 114.537 211.059 114.454 211.412 114.453H229.042C229.395 114.454 229.743 114.537 230.058 114.695C230.373 114.854 230.647 115.083 230.859 115.365C231.071 115.647 231.214 115.975 231.278 116.322C231.342 116.669 231.324 117.026 231.226 117.365L228.576 126.374C228.437 126.846 228.15 127.26 227.756 127.554C227.362 127.848 226.883 128.006 226.392 128.005Z",
    fill: "#263238"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M220.227 141.966C219.933 141.966 219.652 141.849 219.444 141.642C219.237 141.434 219.12 141.153 219.12 140.859C219.12 140.565 219.237 140.284 219.444 140.076C219.652 139.869 219.933 139.752 220.227 139.752C221.257 139.752 222.244 139.343 222.973 138.615C223.701 137.887 224.11 136.899 224.11 135.869C224.11 134.839 223.701 133.851 222.973 133.123C222.244 132.395 221.257 131.986 220.227 131.986C219.933 131.986 219.652 131.869 219.444 131.662C219.237 131.454 219.12 131.173 219.12 130.879V128.005C219.146 127.728 219.274 127.471 219.48 127.284C219.686 127.097 219.954 126.993 220.232 126.993C220.51 126.993 220.778 127.097 220.983 127.284C221.189 127.471 221.317 127.728 221.343 128.005V129.86C222.833 130.142 224.164 130.97 225.077 132.181C225.989 133.392 226.418 134.9 226.278 136.41C226.139 137.92 225.441 139.324 224.323 140.348C223.204 141.372 221.743 141.941 220.227 141.946V141.966Z",
    fill: "#263238"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M391.547 156.712C392.78 159.557 393.79 162.256 394.78 165.09C395.77 167.925 396.673 170.721 397.44 173.634C398.28 176.607 398.954 179.624 399.46 182.672C399.746 184.301 399.947 185.944 400.061 187.594C400.209 189.536 400.161 191.487 399.916 193.419L399.858 193.817C399.831 194.008 399.788 194.196 399.731 194.38C398.858 197.035 397.811 199.63 396.596 202.147C395.46 204.583 394.169 206.884 392.887 209.166C391.606 211.447 390.208 213.631 388.761 215.796C387.315 217.961 385.849 220.058 384.198 222.145C383.647 222.833 382.873 223.306 382.009 223.482C381.146 223.658 380.248 223.525 379.472 223.107C378.696 222.689 378.091 222.012 377.763 221.194C377.434 220.377 377.403 219.47 377.674 218.631V218.544C378.451 216.204 379.315 213.816 380.14 211.466C380.966 209.117 381.82 206.787 382.606 204.457C383.393 202.127 384.179 199.807 384.878 197.545C385.577 195.283 386.189 193.011 386.616 190.943L386.431 191.914C386.411 190.979 386.317 190.048 386.15 189.128C385.956 188.011 385.713 186.788 385.402 185.555C385.091 184.322 384.752 183.06 384.373 181.788C383.994 180.517 383.606 179.235 383.179 177.905C382.325 175.333 381.441 172.731 380.5 170.139L377.655 162.44L377.606 162.304C376.866 160.459 376.889 158.396 377.67 156.568C378.451 154.74 379.926 153.297 381.771 152.557C383.616 151.817 385.679 151.84 387.507 152.621C389.335 153.402 390.778 154.877 391.518 156.722L391.547 156.712Z",
    fill: "url(#paint24_linear_484_4922)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M391.547 156.712C392.78 159.557 393.79 162.256 394.78 165.09C395.77 167.925 396.673 170.721 397.44 173.634C398.28 176.607 398.954 179.624 399.46 182.672C399.746 184.301 399.947 185.944 400.061 187.594C400.209 189.536 400.161 191.487 399.916 193.419L399.858 193.817C399.831 194.008 399.788 194.196 399.731 194.38C398.858 197.035 397.811 199.63 396.596 202.147C395.46 204.583 394.169 206.884 392.887 209.166C391.606 211.447 390.208 213.631 388.761 215.796C387.315 217.961 385.849 220.058 384.198 222.145C383.647 222.833 382.873 223.306 382.009 223.482C381.146 223.658 380.248 223.525 379.472 223.107C378.696 222.689 378.091 222.012 377.763 221.194C377.434 220.377 377.403 219.47 377.674 218.631V218.544C378.451 216.204 379.315 213.816 380.14 211.466C380.966 209.117 381.82 206.787 382.606 204.457C383.393 202.127 384.179 199.807 384.878 197.545C385.577 195.283 386.189 193.011 386.616 190.943L386.431 191.914C386.411 190.979 386.317 190.048 386.15 189.128C385.956 188.011 385.713 186.788 385.402 185.555C385.091 184.322 384.752 183.06 384.373 181.788C383.994 180.517 383.606 179.235 383.179 177.905C382.325 175.333 381.441 172.731 380.5 170.139L377.655 162.44L377.606 162.304C376.866 160.459 376.889 158.396 377.67 156.568C378.451 154.74 379.926 153.297 381.771 152.557C383.616 151.817 385.679 151.84 387.507 152.621C389.335 153.402 390.778 154.877 391.518 156.722L391.547 156.712Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M378.121 217.32L373.16 219.922L380.102 227.135C381.431 226.187 382.618 225.052 383.626 223.767C384.308 222.846 384.598 221.692 384.435 220.558C384.271 219.424 383.666 218.4 382.752 217.709C382.096 217.213 381.312 216.913 380.493 216.844C379.673 216.776 378.851 216.941 378.121 217.32Z",
    fill: "#7F3E3B"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M370.461 228.184L373.325 230.3C373.877 230.706 374.555 230.904 375.238 230.86C375.922 230.815 376.568 230.531 377.063 230.058L380.063 227.145L373.121 219.932L369.937 224.116C369.47 224.726 369.264 225.496 369.362 226.258C369.46 227.02 369.855 227.712 370.461 228.184Z",
    fill: "#7F3E3B"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M299.047 171.333L293.931 164.731L288.058 172.838C288.058 172.838 293.417 178.245 296.746 175.866L299.047 171.333Z",
    fill: "#7F3E3B"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M285.34 163.576L283.757 166.76C283.455 167.376 283.379 168.079 283.545 168.745C283.71 169.411 284.105 169.998 284.66 170.401L288.058 172.838L293.931 164.731L289.271 162.294C288.93 162.119 288.556 162.013 288.173 161.982C287.79 161.952 287.404 161.997 287.039 162.116C286.673 162.235 286.335 162.426 286.043 162.676C285.752 162.927 285.513 163.233 285.34 163.576Z",
    fill: "#7F3E3B"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M383.917 370.846H377.762L377.004 370.137L375.869 370.846C372.112 370.846 367.044 370.71 364.627 369.875C364.557 369.592 364.566 369.296 364.653 369.019C364.74 368.741 364.903 368.493 365.122 368.302C365.122 368.302 375.073 365.225 375.966 363.157H383.509",
    fill: "#263238"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M376.286 283.812C375.053 251.988 377.063 226.834 374.043 214.631L345.89 210.078C345.89 210.078 351.074 263.988 357.306 286.287C363.539 308.587 374.781 363.662 374.781 363.662H384.363C384.363 363.662 384.596 309.927 376.286 283.812Z",
    fill: "url(#paint25_linear_484_4922)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M355.899 236.737L350.666 250.328C352.336 262.221 354.336 274.385 356.491 283.123C358.811 267.259 357.132 241.241 355.899 236.737Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M304.174 361.72C304.174 361.72 318.338 362.798 319.891 361.089L327.318 363.37L325.241 370.846L320.658 369.448L320.144 368.545L318.804 368.875C315.095 367.739 305.29 364.584 303.174 363.05C303.204 362.758 303.313 362.48 303.489 362.246C303.665 362.011 303.902 361.83 304.174 361.72Z",
    fill: "#263238"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M346.511 285.744C355.98 262.52 362.251 238.117 365.151 213.204L334.414 208.176C334.414 208.176 329.852 263.774 327.861 286.627C325.803 310.383 317.813 361.002 317.813 361.002L327.745 364.011C327.745 364.011 345.482 315.296 346.511 285.744Z",
    fill: "url(#paint26_linear_484_4922)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M376.626 127.083C374.82 132.908 373.713 141.344 375.461 146.111C372.063 148.46 366.724 151.198 360.248 150.159C353.773 149.121 355.617 144.917 357.675 142.917C362.656 141.257 363.18 138.917 362.355 136.675L376.626 127.083Z",
    fill: "#7F3E3B"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M381.285 148.441C379.774 146.625 378.125 144.928 376.354 143.364C374.839 142.315 362.267 140.752 359.267 140.859C356.267 140.966 352.103 144.8 352.103 144.8L381.285 148.441Z",
    fill: "url(#paint27_linear_484_4922)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M381.285 148.441C379.774 146.625 378.125 144.928 376.354 143.364C374.839 142.315 362.267 140.752 359.267 140.859C356.267 140.966 352.103 144.8 352.103 144.8L381.285 148.441Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M359.782 120.122C359.588 120.695 359.132 121.093 358.763 120.938C358.394 120.782 358.229 120.239 358.423 119.656C358.617 119.074 359.073 118.685 359.442 118.85C359.811 119.015 359.976 119.549 359.782 120.122Z",
    fill: "#263238"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M359.558 120.938C358.295 122.462 356.829 123.804 355.199 124.928C355.498 125.341 355.882 125.684 356.326 125.934C356.771 126.184 357.264 126.334 357.772 126.374L359.558 120.938Z",
    fill: "#630F0F"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M359.782 116.152C359.805 116.206 359.843 116.253 359.891 116.287C359.939 116.321 359.995 116.342 360.054 116.346C360.497 116.391 360.924 116.54 361.298 116.781C361.673 117.023 361.985 117.349 362.209 117.734C362.228 117.776 362.255 117.814 362.289 117.846C362.323 117.877 362.363 117.902 362.407 117.917C362.45 117.933 362.497 117.939 362.543 117.936C362.589 117.933 362.634 117.92 362.675 117.899C362.76 117.857 362.824 117.784 362.855 117.695C362.886 117.606 362.881 117.508 362.84 117.423C362.567 116.931 362.179 116.511 361.709 116.2C361.24 115.889 360.702 115.696 360.141 115.637C360.079 115.634 360.016 115.646 359.959 115.674C359.903 115.701 359.854 115.743 359.818 115.794C359.782 115.846 359.76 115.906 359.754 115.968C359.747 116.031 359.757 116.094 359.782 116.152Z",
    fill: "#263238"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M379.713 125.025C376.946 131.937 375.684 136.131 370.975 138.548C363.82 142.189 356.18 135.995 356.821 128.374C357.394 121.52 361.811 111.365 369.636 110.899C371.365 110.802 373.091 111.144 374.653 111.893C376.214 112.643 377.561 113.775 378.567 115.185C379.573 116.595 380.205 118.237 380.406 119.957C380.606 121.678 380.368 123.421 379.713 125.025Z",
    fill: "#7F3E3B"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M364.17 125.248C363.981 126.814 364.122 128.402 364.586 129.91C365.049 131.418 365.824 132.811 366.86 134.001C367.895 135.191 369.169 136.149 370.599 136.816C372.029 137.482 373.582 137.841 375.16 137.869C382.111 137.869 382.217 127.966 380.984 125.685C384.674 125.044 386.809 119.977 384.557 116.773C387.945 114.113 380.111 110.074 370.577 109.55C360.063 108.967 361.986 115.161 365.49 117.035C362.121 118.035 361.772 124.035 364.17 125.248Z",
    fill: "#263238"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M362.15 112.2C362.15 112.2 362.82 120.345 369.665 125.248C376.509 130.151 382.596 130.607 382.596 130.607L384.285 125.248C384.285 125.248 368.83 115.938 363.607 110.734C363.093 111.194 362.606 111.683 362.15 112.2Z",
    fill: "url(#paint28_linear_484_4922)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M362.15 112.2C362.15 112.2 362.82 120.345 369.665 125.248C376.509 130.151 382.596 130.607 382.596 130.607L384.285 125.248C384.285 125.248 368.83 115.938 363.607 110.734C363.093 111.194 362.606 111.683 362.15 112.2Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M367.802 125.345C366.909 126.66 365.547 127.583 363.996 127.928C362.054 128.306 361.433 126.326 362.297 124.413C363.074 122.695 365.035 120.423 366.85 120.909C368.666 121.394 368.967 123.675 367.802 125.345Z",
    fill: "#7F3E3B"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M380.985 147.567C371.141 144.859 356.899 142.898 347.21 143.16C344.814 143.234 342.509 144.101 340.659 145.627C338.809 147.152 337.518 149.248 336.988 151.586C333.706 165.819 333.201 191.468 332.25 217.223C353.375 227.902 377.034 223.67 377.034 223.67C378.286 218.631 378.005 201.477 377.568 192.273C380.189 183.225 384.936 173.119 388.538 161.12C388.948 159.734 389.078 158.28 388.919 156.844C388.759 155.408 388.315 154.018 387.612 152.755C386.908 151.493 385.96 150.384 384.822 149.493C383.684 148.602 382.379 147.947 380.985 147.567Z",
    fill: "url(#paint29_linear_484_4922)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M380.985 147.567C371.141 144.859 356.899 142.898 347.21 143.16C344.814 143.234 342.509 144.101 340.659 145.627C338.809 147.152 337.518 149.248 336.988 151.586C333.706 165.819 333.201 191.468 332.25 217.223C353.375 227.902 377.034 223.67 377.034 223.67C378.286 218.631 378.005 201.477 377.568 192.273C380.189 183.225 384.936 173.119 388.538 161.12C388.948 159.734 389.078 158.28 388.919 156.844C388.759 155.408 388.315 154.018 387.612 152.755C386.908 151.493 385.96 150.384 384.822 149.493C383.684 148.602 382.379 147.947 380.985 147.567Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M349.938 141.733C341.822 141.267 336.773 145.276 334.706 157.528C332.638 169.78 330.405 197.555 331.269 207.574C358.52 219.039 375.422 214.369 379.062 211.7C380.489 209.515 379.965 202.729 379.247 200.05C381.071 195.238 381.983 190.128 381.936 184.983C385.975 181.099 387.761 173.653 387.897 170.76C391.45 166.023 391.926 155.295 389.955 152.237C387.984 149.179 382.256 143.538 349.938 141.733Z",
    fill: "#263238"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M335.182 209.622C335.053 209.622 334.93 209.571 334.838 209.48C334.747 209.389 334.696 209.265 334.696 209.137C334.696 189.448 337.327 160.411 341.026 150.227C341.07 150.106 341.16 150.008 341.276 149.953C341.393 149.899 341.526 149.892 341.647 149.936C341.708 149.957 341.764 149.989 341.812 150.032C341.859 150.075 341.898 150.127 341.925 150.185C341.953 150.243 341.968 150.306 341.97 150.37C341.972 150.434 341.962 150.498 341.939 150.557C338.628 159.673 335.687 187.05 335.667 209.137C335.667 209.2 335.655 209.263 335.63 209.322C335.606 209.381 335.57 209.435 335.525 209.48C335.48 209.525 335.426 209.561 335.367 209.585C335.309 209.609 335.245 209.622 335.182 209.622Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M349.802 155.188C348.326 157.877 346.831 160.275 345.219 162.751C343.608 165.226 341.919 167.605 340.074 169.954C338.218 172.386 336.222 174.707 334.094 176.905C332.95 178.098 331.738 179.223 330.463 180.274C328.974 181.534 327.346 182.619 325.609 183.507L325.259 183.682C325.084 183.767 324.902 183.838 324.716 183.895C321.801 184.752 318.751 185.049 315.726 184.769C314.374 184.664 313.031 184.466 311.707 184.177C310.439 183.917 309.185 183.593 307.95 183.206C305.582 182.445 303.277 181.501 301.057 180.381C299.96 179.827 298.902 179.235 297.853 178.614C296.805 177.993 295.834 177.352 294.737 176.556C294.033 176.049 293.527 175.314 293.304 174.477C293.082 173.639 293.157 172.749 293.516 171.96C293.876 171.171 294.498 170.532 295.276 170.15C296.055 169.768 296.941 169.668 297.785 169.867L298.115 169.945L301.154 170.653C302.183 170.896 303.222 171.11 304.251 171.304C306.254 171.699 308.276 171.99 310.309 172.177C312.166 172.346 314.034 172.346 315.891 172.177C317.372 172.066 318.824 171.702 320.182 171.1L319.289 171.498C319.983 170.988 320.633 170.419 321.231 169.799C321.978 169.032 322.784 168.158 323.56 167.226C324.337 166.294 325.114 165.285 325.871 164.265C326.628 163.246 327.415 162.188 328.162 161.1C329.647 158.945 331.133 156.722 332.579 154.46C334.026 152.198 335.492 149.858 336.832 147.664L336.9 147.548C337.401 146.701 338.065 145.961 338.852 145.37C339.64 144.779 340.537 144.349 341.49 144.105C342.444 143.861 343.437 143.807 344.411 143.946C345.386 144.085 346.324 144.415 347.171 144.917C348.018 145.419 348.758 146.082 349.349 146.87C349.939 147.658 350.369 148.554 350.613 149.508C350.858 150.461 350.912 151.454 350.773 152.429C350.633 153.403 350.303 154.341 349.802 155.188Z",
    fill: "url(#paint30_linear_484_4922)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M349.802 155.188C348.326 157.877 346.831 160.275 345.219 162.751C343.608 165.226 341.919 167.605 340.074 169.954C338.218 172.386 336.222 174.707 334.094 176.905C332.95 178.098 331.738 179.223 330.463 180.274C328.974 181.534 327.346 182.619 325.609 183.507L325.259 183.682C325.084 183.767 324.902 183.838 324.716 183.895C321.801 184.752 318.751 185.049 315.726 184.769C314.374 184.664 313.031 184.466 311.707 184.177C310.439 183.917 309.185 183.593 307.95 183.206C305.582 182.445 303.277 181.501 301.057 180.381C299.96 179.827 298.902 179.235 297.853 178.614C296.805 177.993 295.834 177.352 294.737 176.556C294.033 176.049 293.527 175.314 293.304 174.477C293.082 173.639 293.157 172.749 293.516 171.96C293.876 171.171 294.498 170.532 295.276 170.15C296.055 169.768 296.941 169.668 297.785 169.867L298.115 169.945L301.154 170.653C302.183 170.896 303.222 171.11 304.251 171.304C306.254 171.699 308.276 171.99 310.309 172.177C312.166 172.346 314.034 172.346 315.891 172.177C317.372 172.066 318.824 171.702 320.182 171.1L319.289 171.498C319.983 170.988 320.633 170.419 321.231 169.799C321.978 169.032 322.784 168.158 323.56 167.226C324.337 166.294 325.114 165.285 325.871 164.265C326.628 163.246 327.415 162.188 328.162 161.1C329.647 158.945 331.133 156.722 332.579 154.46C334.026 152.198 335.492 149.858 336.832 147.664L336.9 147.548C337.401 146.701 338.065 145.961 338.852 145.37C339.64 144.779 340.537 144.349 341.49 144.105C342.444 143.861 343.437 143.807 344.411 143.946C345.386 144.085 346.324 144.415 347.171 144.917C348.018 145.419 348.758 146.082 349.349 146.87C349.939 147.658 350.369 148.554 350.613 149.508C350.858 150.461 350.912 151.454 350.773 152.429C350.633 153.403 350.303 154.341 349.802 155.188Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M384.422 128.656C384.296 128.779 384.139 128.866 383.968 128.907C383.797 128.948 383.618 128.941 383.451 128.889C377.993 126.803 372.969 123.722 368.636 119.802C361.287 113.064 360.656 105.346 363.918 109.035C365.724 107.094 373.393 104.725 380.499 107.803C388.014 111.074 391.635 121.21 384.422 128.656Z",
    fill: "url(#paint31_linear_484_4922)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M378.141 106.987C379.989 108.741 381.313 110.975 381.964 113.439C382.616 115.903 382.569 118.499 381.83 120.938C383.411 120.594 384.93 120.012 386.334 119.21C386.334 119.21 387.47 113.763 385.364 110.259C383.257 106.754 378.597 105.871 378.141 106.987Z",
    fill: "url(#paint32_linear_484_4922)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M381.83 120.938C382.569 118.499 382.616 115.903 381.964 113.439C381.313 110.975 379.989 108.741 378.141 106.987C378.203 106.878 378.289 106.785 378.394 106.716C378.498 106.647 378.618 106.603 378.743 106.589C380.218 107.541 384.286 113.317 381.83 120.938Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_484_4922",
    x1: 133.698,
    y1: 51.864,
    x2: 133.698,
    y2: 142.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_484_4922",
    x1: 163.332,
    y1: 51.7505,
    x2: 163.332,
    y2: 142.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_484_4922",
    x1: 148.522,
    y1: 51.8152,
    x2: 148.522,
    y2: 83.7865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_484_4922",
    x1: 148.513,
    y1: 37.042,
    x2: 148.513,
    y2: 54.0778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_484_4922",
    x1: 178.156,
    y1: 37.042,
    x2: 178.156,
    y2: 54.0778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_484_4922",
    x1: 207.772,
    y1: 37.042,
    x2: 207.772,
    y2: 54.0782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_484_4922",
    x1: 148.479,
    y1: 81.5535,
    x2: 148.479,
    y2: 113.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_484_4922",
    x1: 148.547,
    y1: 81.5146,
    x2: 148.547,
    y2: 113.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_484_4922",
    x1: 115.418,
    y1: 52.9709,
    x2: 115.418,
    y2: 68.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_484_4922",
    x1: 115.39,
    y1: 51.864,
    x2: 115.39,
    y2: 70.0766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_484_4922",
    x1: 178.265,
    y1: 37.0349,
    x2: 178.265,
    y2: 39.2678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_484_4922",
    x1: 181.03,
    y1: 102.716,
    x2: 181.03,
    y2: 365.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_484_4922",
    x1: 195.01,
    y1: 102.716,
    x2: 195.01,
    y2: 365.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_484_4922",
    x1: 254.866,
    y1: 117.453,
    x2: 135.155,
    y2: 117.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_484_4922",
    x1: 156.898,
    y1: 269.947,
    x2: 173.177,
    y2: 309.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_484_4922",
    x1: 220.227,
    y1: 274.609,
    x2: 220.227,
    y2: 279.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_484_4922",
    x1: 220.227,
    y1: 286.938,
    x2: 220.227,
    y2: 292.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_484_4922",
    x1: 220.227,
    y1: 299.267,
    x2: 220.227,
    y2: 304.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_484_4922",
    x1: 209.549,
    y1: 130.36,
    x2: 209.549,
    y2: 261.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_484_4922",
    x1: 263.195,
    y1: 231.866,
    x2: 162.091,
    y2: 239.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_484_4922",
    x1: 209.075,
    y1: 176.117,
    x2: 157.449,
    y2: 180.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_484_4922",
    x1: 256.085,
    y1: 144.868,
    x2: 212.521,
    y2: 148.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_484_4922",
    x1: 258.218,
    y1: 172.283,
    x2: 214.654,
    y2: 175.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_484_4922",
    x1: 260.361,
    y1: 199.699,
    x2: 216.797,
    y2: 203.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_484_4922",
    x1: 388.606,
    y1: 152.018,
    x2: 388.606,
    y2: 223.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_484_4922",
    x1: 365.127,
    y1: 210.078,
    x2: 365.127,
    y2: 363.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_484_4922",
    x1: 341.482,
    y1: 208.176,
    x2: 341.482,
    y2: 364.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_484_4922",
    x1: 366.694,
    y1: 140.854,
    x2: 366.694,
    y2: 148.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_484_4922",
    x1: 373.218,
    y1: 110.734,
    x2: 373.218,
    y2: 130.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_484_4922",
    x1: 360.617,
    y1: 143.136,
    x2: 360.617,
    y2: 224.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_484_4922",
    x1: 322.013,
    y1: 143.871,
    x2: 322.013,
    y2: 184.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_484_4922",
    x1: 375.186,
    y1: 106.321,
    x2: 375.186,
    y2: 128.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_484_4922",
    x1: 382.39,
    y1: 106.532,
    x2: 382.39,
    y2: 120.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobAppContact);
export default __webpack_public_path__ + "static/media/MobApp-Contact.35a0b39ef8fe208c263c702a14eee81f.svg";
export { ForwardRef as ReactComponent };